[
    {
        "title": "Volume 4 of In Search of Lost Time",
        "author": "Marcel Proust",
        "link": "https://www.amazon.com/Sodom-Gomorrah-Search-Penguin-Classics/dp/0143039318"
    },
    {
        "title": "The Fellowship of the Ring",
        "author": "J.R.R. Tolkien",
        "link": "https://www.amazon.com/The-Fellowship-of-Ring-audiobook/dp/B0099SNQYG/ref=sr_1_1?crid=YNCRBEEEPHI&keywords=fellowship+of+the+ring&qid=1702930825&s=books&sprefix=Fellowship%2Cstripbooks%2C171&sr=1-1"
    },
    {
        "title": "Metamorphoses",
        "author": "Ovid",
        "link": "https://www.amazon.com/Metamorphoses-Ovid-audiobook/dp/B00134DD7O/ref=sr_1_1?crid=1SSXYCF2NSLE9&keywords=metamorphoses&qid=1702930890&s=audible&sprefix=metamorphosis%2Caudible%2C219&sr=1-1"
    }
]